


import React, { useState } from "react";
import { Button, Table, Alert, Form } from "react-bootstrap";
import axios from "axios";
import UserManagementNew from "./UserManagementNew";
import "./usercss/UserManagement.css";
import useTranslations from '../transalation/TranslationUtils';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getAdminList } from "app/redux/slices/rdxMainSlice";
import { Dialog, DialogActions, DialogContent, DialogTitle, Snackbar } from "@mui/material";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { DEFAULT_IP } from "app/utils/constant";

const UserManagement = () => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const users = useSelector((state) => state.rdxMain?.adminList || {});
  const [errorObj, setErrorObj] = useState({ msg: "", isOpen: false });
  const [successObj, setSuccessObj] = useState({ msg: "", isOpen: false });
  const permissions = useSelector((state) => state.rdxMain?.pagePermissions?.admin || {});
  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const { func_t, role_edit, role_Add, role_delete, role_next, role_previous,
    change_pass, user_manage, username, showErrMsg, showSuccessMsg, cancel, confirm,
    password } = useTranslations();

  const [pwdOpen, setPwdOpen] = useState(false);
  const [tmpPwdInfo, setTmpPwdInfo] = useState({
    admin_name: "",
    admin_id: "",
    new_password: "",
    showPwd: false
  });

  const fetchUsers = async () => {
    dispatch(getAdminList());
  };

  const handleAddUser = () => {
    setSelectedUser({});
    setShowModal(true);
  };

  const handleEditUser = (user) => {
    setSelectedUser(user);
    setShowModal(true);
  };

  const handleDeleteUser = async (user) => {
    if (
      window.confirm(
        `Are you sure you want to delete User ${user.admin_name || "Unnamed Admin"}?`
      )
    ) {
      try {
        const response = await axios.post(
          DEFAULT_IP + "/webapp/memportal/deleteadmin",
          {
            admin_id: user.admin_id,
          }
        );
        if (response.data.code === 1) {
          setSuccessObj({
            msg: `User ${user.admin_name || "Unnamed Admin"} deleted successfully!`,
            isOpen: true
          });
          fetchUsers();
        } else if (user.admin_name === "Root Admin") {
          setErrorObj({ msg: `Root Account cannot be deleted`, isOpen: true });
        } else {
          console.error("Failed to delete admin:", response.data.message_en);
          setErrorObj({ msg: `An account currently logged in cannot be deleted`, isOpen: true });
        }
      } catch (error) {
        console.error("Error deleting admin:", error);
        setErrorObj({ msg: "An error occurred while deleting the admin.", isOpen: true });
      }
    }
  };




  const handleCloseModal = () => setShowModal(false);

  const totalPages = Math.ceil(users.length / rowsPerPage);
  const paginatedUsers = users.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleChangePwd = async () => {
    if (!tmpPwdInfo.new_password) {
      setErrorObj({ msg: "Please enter a password.", isOpen: true });
      return;
    }

    const postRes = await axios.post(DEFAULT_IP + "/webapp/memportal/changepassword",
      {
        admin_id: tmpPwdInfo.admin_id,
        new_password: tmpPwdInfo.new_password
      });

    let data = postRes.data;

    if (1 == data?.code) {
      setSuccessObj({ msg: showSuccessMsg(data), isOpen: true });
    } else {
      setErrorObj({ msg: showErrMsg(data), isOpen: true });
    }

    setTmpPwdInfo({
      admin_name: "",
      admin_id: "",
      new_password: "",
      showPwd: false
    });
    setPwdOpen(false);
  };

  const handlePwdCancel = () => {
    setTmpPwdInfo({
      admin_name: "",
      admin_id: "",
      new_password: "",
      showPwd: false
    });
    setPwdOpen(false);
  };

  return (
    <div className="container-fluid pt-5 ps-3 pe-3">

      <div className="row mb-3">
        <div className="col-10 d-flex align-items-center">
          <h4 className="firstname">{user_manage()}</h4>
        </div>
        <div className="col-2 d-flex justify-content-end">
          {permissions.add && (
            <Button
              className="custom-success-btn me-3"
              variant="success"
              onClick={handleAddUser}
            >
              {role_Add()}
            </Button>
          )}
        </div>
      </div>

      <>
        <div className="table-responsive">
          <Table className="role-management-table">
            <thead>
              <tr className="tabaleh">
                <th style={{ width: "78%" }} className="tabaleh">
                  {username()}
                </th>
                <th style={{ width: "22.5%" }} className="tabaleh">
                  <div className=" d-flex justify-content-center align-items-center">
                    {func_t()}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {paginatedUsers.length > 0 ? (
                paginatedUsers.map((user, index) => (
                  <tr key={user.admin_id || index}>
                    <td className="role align-middle">{user.admin_name}</td>
                    <td>
                      <div className="button-group d-flex justify-content-end align-items-end">
                        {permissions.edit && (
                          <Button
                            className="custom-success-btn me-2"
                            onClick={() => handleEditUser(user)}
                          >
                            {role_edit()}
                          </Button>
                        )}
                        {permissions.edit && (
                          <Button className="custom-success-btn1 me-2"
                            onClick={() => {
                              setTmpPwdInfo({
                                admin_name: user.admin_name,
                                admin_id: user.admin_id,
                                new_password: "",
                                showPwd: false
                              });
                              setPwdOpen(true);
                            }}>
                            {change_pass()}
                          </Button>
                        )}
                        {permissions.delete && (
                          <Button
                            className="custom-danger-btn"
                            onClick={() => handleDeleteUser(user)}
                          >
                            {role_delete()}
                          </Button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2" className="text-center">
                    No admins available.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>


        <nav aria-label="Page navigation example" className="mt-5">
          <ul className="pagination justify-content-end">
            {/* Previous Button */}
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className={`page-link ${currentPage !== 1 ? "text-success" : ""}`}
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                {role_previous()}
              </button>
            </li>

            {/* Page Numbers */}
            {[...Array(totalPages).keys()].map((page) => (
              <li
                key={page}
                className={`page-item ${currentPage === page + 1 ? "active" : ""}`}
              >
                <button
                  className={`page-link ${currentPage === page + 1 ? "bg-success text-white" : "text-success"}`}
                  onClick={() => handlePageChange(page + 1)}
                >
                  {page + 1}
                </button>
              </li>
            ))}

            {/* Next Button */}
            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
              <button
                className={`page-link ${currentPage !== totalPages ? "text-success" : ""}`}
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                {role_next()}
              </button>
            </li>
          </ul>
        </nav>
      </>

      <UserManagementNew
        show={showModal}
        handleClose={handleCloseModal}
        modalTitle={selectedUser.role_id ? "Edit User" : "Add User"}
        userData={selectedUser}
        fetchUsers={fetchUsers}
      />

      <Dialog
        open={pwdOpen}
        onClose={handlePwdCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{tmpPwdInfo?.admin_name} - {change_pass()}</DialogTitle>
        <DialogContent>
          <Form.Group controlId="changePwd" className="floating-label-group position-relative">
            <Form.Control
              type={tmpPwdInfo.showPwd ? "text" : "password"} // Toggle input type
              name="changePwd"
              className="floating-input"
              value={tmpPwdInfo.new_password}
              onChange={(e) => {
                let val = e.target?.value;
                if (!val) { val = ""; }
                setTmpPwdInfo((prevState) => ({
                  ...prevState,
                  new_password: val
                }));
              }}
            />
            <Form.Label className="floating-label">{password()}</Form.Label>
            <span
              onClick={() => {
                setTmpPwdInfo((prevState) => ({
                  ...prevState,
                  showPwd: !prevState.showPwd
                }));
              }}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                color: "#6c757d",
              }}
            >
              {tmpPwdInfo.showPwd ? <FaEyeSlash /> : <FaEye />}
            </span>
          </Form.Group>
        </DialogContent>
        <DialogActions>
          <Button onClick={handlePwdCancel}>{cancel()}</Button>
          <Button onClick={handleChangePwd}>{confirm()}</Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={successObj.isOpen}
        autoHideDuration={1500}
        onClose={() => { setSuccessObj(prevState => ({ ...prevState, isOpen: false })); }}>
        <Alert variant="success">{successObj.msg}</Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={errorObj.isOpen}
        autoHideDuration={1500}
        onClose={() => { setErrorObj(prevState => ({ ...prevState, isOpen: false })); }}>
        <Alert variant="danger">{errorObj.msg}</Alert>
      </Snackbar>
    </div>
  );
};

export default UserManagement;
